import React, { useState, useRef, useContext } from 'react';
import AuthContext from '../../../contexts/auth';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
// icons
import * as FiIcons from 'react-icons/fi';
// components
import Spinner from '../../../components/Spinner';
import {translate} from "../../../utils/Common";

const FormResetPwd = ({ setResetPwdSuccess, id }) => {    
    const userContext = useContext(AuthContext);
    const { handleSubmit, reset, register, errors, setError, watch } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isPwdVisible, setIsPwdVisible] = useState(false);
    const [isPwdConfirmVisible, setIsPwdConfirmVisible] = useState(false);
    const pwd = useRef({});
    pwd.current = watch("pwd","");
    // para validar números, letras y caracteres especiales
    const regexLetras = /[a-zA-Z]+/;
    const regexNum = /[0-9]+/;
    const regexChar = /["#$%&/()=¿?¡!_.,+*']+/;

    const sendNewPwd = async (data) => {
        try {
            setIsLoading(true);
            const result = await userContext.resetPwd(data, id);
            setIsLoading(false);
            
            switch (result) {
                case 'PWD_RESTABLISHED_SUCCESSFULLY':
                    reset();
                    setResetPwdSuccess(true);
                    break;
                
                    
                case 'TOKEN_EXPIRED':
                    reset();
                    setError('pwd', { type: '', message: translate("login.resetpwd.validate.tokenExpired") });
                    break;
                
                default:
                    setError('pwd', { type: '', message: translate("login.resetpwd.validate.defaultError") });
                    break;
            }
        } catch (error) {
            setError('pwd', { type: '', message: translate("login.resetpwd.validate.catchError") });
        }
    }

    return (
        <form className='text-center' onSubmit={ handleSubmit(sendNewPwd) }>
            <div className="title">
                <h5 className="mb-2">{translate("login.resetpwd.title")}</h5>
                <p className="mb-2">{translate("login.resetpwd.instructions")}</p>
            </div>

            <div className="flex flex-wrap -mx-2 text-left mb-2 px-3">
                <label htmlFor="inputPwd" className="mb-1"><span className="text-destructive">*</span> {translate("login.resetpwd.password")}:</label>
                <div className="flex w-full items-stretch">
                    <div className="flex items-center" onClick={ () => setIsPwdVisible(!isPwdVisible) }>
                        <span className="flex items-center px-3 text-muted-foreground" id="span-eye-pwd">
                            { !isPwdVisible ?
                                <FiIcons.FiEye size={16} className="text-dark"/>
                                :
                                <FiIcons.FiEyeOff size={16} className="text-dark"/>   
                            }
                        </span>
                    </div>
                    <input type={ isPwdVisible ? "text" : "password" } maxLength={15} className={ "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " + (errors.pwd ? "border-destructive" : "") } id="inputPwd" name="pwd" required ref={register({
                        minLength: {
                            value: 6,
                            message: translate("login.resetpwd.validate.minLength")
                        },
                        maxLength: {
                            value: 16,
                            message: translate("login.resetpwd.validate.maxLength")
                        },
                        validate: value => (regexLetras.test(value) && regexNum.test(value) && regexChar.test(value)) || 'La contraseña no cumple con los parámetros solicitados',
                    })}/>
                    {errors.pwd && <div className="mt-1 text-xs font-medium text-destructive">{errors.pwd.message}</div> }
                </div>
            </div>

            <div className="flex flex-wrap -mx-2 text-left mb-2 px-3">
                <label htmlFor="pwdConfirm" className="mb-1"><span className="text-destructive">*</span> {translate("login.resetpwd.confirm")}:</label>
                <div className="flex w-full items-stretch">
                    <div className="flex items-center">
                        <span className="flex items-center px-3 text-muted-foreground" id="span-eye-pwdConfirm" onClick={ () => setIsPwdConfirmVisible(!isPwdConfirmVisible) }>
                            { !isPwdConfirmVisible ?
                                <FiIcons.FiEye size={16} className="text-dark"/>
                                :
                                <FiIcons.FiEyeOff size={16} className="text-dark"/>   
                            }
                        </span>
                    </div>
                    <input type={ isPwdConfirmVisible ? "text" : "password" } maxLength={15} className={ "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " + (errors.pwdConfirm ? "border-destructive" : "") } id="pwdConfirm" name="pwdConfirm" required ref={register({
                        minLength: {
                            value: 6,
                            message: translate("login.resetpwd.validate.minLength")
                        },
                        maxLength: {
                            value: 16,
                            message: translate("login.resetpwd.validate.maxLength")
                        },
                        validate: value => value === pwd.current || translate("login.resetpwd.validate.passNotMatch") 
                    })}/>
                    {errors.pwdConfirm && <div className="mt-1 text-xs font-medium text-destructive">{errors.pwdConfirm.message}</div> }
                </div>
            </div>

            <div className="mb-2 text-left px-3">
                <p className="text-xs m-0 p-0">{translate("login.resetpwd.validate1")}:</p>
                <p className="text-xs m-0 p-0">- {translate("login.resetpwd.validate2")}</p>
                <p className="text-xs m-0 p-0">- {translate("login.resetpwd.validate3")}</p>
                <p className="text-xs m-0 p-0">- {translate("login.resetpwd.validate4")}</p>
            </div>

            <div className="mb-3 mt-2 mb-0">
                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 btn-reset rounded-pill h-12 rounded-md px-8 text-base uppercase m-2" type="submit">
                    { !isLoading ? translate("login.resetpwd.buttonAccept") : <Spinner type={1} size={18} /> }
                </button>
                <Link to='/login'><button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-outline-blue btn-reset rounded-pill h-12 rounded-md px-8 text-base uppercase m-2">{translate("login.resetpwd.buttonReturn")}</button></Link>
            </div>
        </form>
    );
}

export default FormResetPwd;